import { Outlet } from 'react-router-dom'

import { PlazaBackdrop } from '@/components/brand/PlazaBackdrop'
import { Wordmark } from '@/components/brand/Wordmark'
import { useT } from '@/i18n'

export function AuthLayout() {
  const t = useT()
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden py-10 sm:px-4">
      <PlazaBackdrop className="pointer-events-none fixed inset-0" />

      {/*
        表单放在实心卡片上，背景再热闹也不影响读和填。
        像素边框靠两层同样台阶的 px-corners 叠出来：外层是边框色、内缩 2px 的内层是底色。
        （带阶梯角的元素不能直接画 border，四个角会被切断，见 design/04）
        手机上不要卡片的边框与阴影：屏幕本身就是那张卡片，再框一圈是「框中框」。
      */}
      {/* 阴影放在不裁剪的外层用 drop-shadow：box-shadow 会被里层的 clip-path 裁掉 */}
      <div className="relative w-full max-w-[440px] sm:drop-shadow-2xl">
        <div className="sm:px-corners sm:[--px-step:4px] sm:bg-line-strong sm:p-[2px]">
          <div className="bg-surface px-6 py-9 sm:px-corners sm:[--px-step:4px] sm:px-8">
            <Wordmark className="mb-6 block text-center text-[34px]" />
            <Outlet />
            <p className="mt-8 text-center text-[13px] text-ink-muted">
              {t('authLayout.agentHint')}{' '}
              <a href="/doc" className="font-pixel font-bold text-brand-ink hover:underline">
                /doc
              </a>
              {t('authLayout.agentSuffix')}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
